<template>
  <component :is="resolvedComponent"
             :class="{'text-black cursor-default': isSelected}"
             :href="url || undefined"
             :to="route ? { name: route } : undefined"
             class="h-22 flex gap-2 items-center pl-4 font-semibold truncate w-full"
             :target="url ? '_blank' : '_self'"
  >
    <component :is="icon"
               class="w-6"
               :class="{'text-primary': isSelected}"
    />
    <span>{{ label }}</span>
    <vs-icon v-if="url" icon="open_in_new" size="1.2rem" class="text-gray-dark" />
  </component>
</template>

<script>
import WithLoader from '@/components/common/WithLoader.vue'
import BotIcon from '@/assets/images/icons/BotIcon.vue'
import GPTIcon from '@/assets/images/icons/GPTIcon.vue'
import VariablesIcon from '@/assets/images/icons/VariablesIcon.vue'
import ChannelsIcon from '@/assets/images/icons/ChannelsIcon.vue'
import BillingIcon from '@/assets/images/icons/BillingIcon.vue'
import UsersIcon from '@/assets/images/icons/UsersIcon.vue'
import ThemeIcon from '@/assets/images/icons/ThemeIcon.vue'
import IntegrationsIcon from '@/assets/images/icons/IntegrationsIcon.vue'
import AdminIcon from '@/assets/images/icons/AdminIcon.vue'

export default {
  name: 'SettingsListItem',

  components: {
    WithLoader,
    BotIcon,
    GPTIcon,
    VariablesIcon,
    ChannelsIcon,
    BillingIcon,
    UsersIcon,
    ThemeIcon,
    IntegrationsIcon,
    AdminIcon
  },

  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },

  computed: {
    resolvedComponent() {
      if (this.isSelected) return 'div'

      return this.url ? 'a' : 'router-link'
    }
  }
}
</script>

